/* eslint-disable no-shadow */
import { toast } from 'react-toastify';
import { Api } from '../lib/api/api';
import utils from '../lib/utils';
import { assignAction } from './BoxSessionLogging';
import { checkIfIsBoxTab } from './EpikBoxes';

export const getUserNumbers = (token, paginateOptions, id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'USER_NUMBERS',
  });
  try {
    const numbers = await api.numbers.getUserNumbers(paginateOptions, id);
    dispatch({
      type: 'USER_NUMBERS_SUCCESS',
      numbers: {
        ...numbers,
        allNumbers: numbers,
      },
    });
  } catch (error) {
    dispatch({
      type: 'USER_NUMBERS_ERROR',
      error,
    });
  }
};

export const getCompanyNumbers = (token, id, uid, type, gflag) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'COMPANY_NUMBERS',
  });
  try {
    const numbers = await api.numbers.getCompanyNumbers(id, uid, type, gflag);
    dispatch({
      type: 'COMPANY_NUMBERS_SUCCESS',
      numbers,
    });
    return numbers;
  } catch (error) {
    return dispatch({
      type: 'COMPANY_NUMBERS_ERROR',
      error,
    });
  }
};

export const getNumberByID = (token, id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_NUMBERS_BY_ID',
  });
  try {
    const number = await api.numbers.getNumberByID(id);
    dispatch({
      type: 'GET_NUMBERS_BY_ID_SUCCESS',
      number,
    });
    return number;
  } catch (error) {
    return dispatch({
      type: 'GET_NUMBERS_BY_ID_ERROR',
      error,
    });
  }
};
export const getNumberFeaturesByID = (token, id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_NUMBER_FEATURES_BY_ID',
  });
  try {
    const features = await api.numbers.getNumberFeaturesByID(id);
    dispatch({
      type: 'GET_NUMBER_FEATURE_BY_ID_SUCCESS',
      features,
    });
    return features;
  } catch (error) {
    return dispatch({
      type: 'GET_NUMBER_FEATURE_BY_ID_ERROR',
      error,
    });
  }
};
export const updateNumberFeaturesByID = (token, id, body) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_NUMBER_FEATURES_BY_ID',
  });
  try {
    const features = await api.numbers.updateNumberFeaturesByID(id, body);
    dispatch({
      type: 'UPDATE_NUMBER_FEATURE_BY_ID_SUCCESS',
      features,
    });
    return features;
  } catch (error) {
    toast.error(error.response.data);
    // toast(error.data)
    return dispatch({
      type: 'UPDATE_NUMBER_FEATURE_BY_ID_ERROR',
      error,
    });
  }
};

export const getAlarmRelay = (token, bid, portNumber) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_ALARM_RELAY_STATUS',
  });
  try {
    const getAlarmRelayStatus = await api.numbers.getAlarmRelay(bid, portNumber);
    dispatch({
      type: 'GET_ALARM_RELAY_STATUS_SUCCESS',
      alarmStatus: getAlarmRelayStatus,
    });
    return getAlarmRelayStatus;
  } catch (error) {
    return dispatch({
      type: 'GET_ALARM_RELAY_STATUS_ERROR',
      error,
    });
  }
};

export const getAllNumbers = (
  token,
  paginateOptions,
  id,
  type,
  disablePaginate,
  carrier,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ALL_NUMBERS',
  });
  try {
    const numbers = await api.numbers.getAllNumbers(
      paginateOptions,
      id,
      type,
      disablePaginate,
      carrier,
    );
    return dispatch({
      type: 'ALL_NUMBERS_SUCCESS',
      numbers: {
        allNumbers: numbers,
      },
    });
  } catch (error) {
    return dispatch({
      type: 'ALL_NUMBERS_ERROR',
      error,
    });
  }
};

export const updateObiByNumber = (token, obiNumber, body, type) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_OBI_BY_NUMBER',
  });
  try {
    const numbers = await api.numbers.updateObiByNumber(obiNumber, checkIfIsBoxTab(body), type);
    dispatch({
      type: 'UPDATE_OBI_BY_NUMBER_SUCCESS',
      numbers: {
        allNumbers: numbers,
      },
    });
    // [Action] - assign
    dispatch(assignAction(`Number Assigned ${body?.number}`));
    return true;
  } catch (error) {
    dispatch({
      type: 'UPDATE_OBI_BY_NUMBER_ERROR',
      error,
    });
    return false;
  }
};

export const updateAtaByNumber = (token, ataNumber, body, type) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_ATA_BY_NUMBER',
  });
  try {
    const updatedAta = await api.numbers.updateAtaByNumber(ataNumber, checkIfIsBoxTab(body), type);
    dispatch({
      type: 'UPDATE_ATA_BY_NUMBER_SUCCESS',
      updatedAta,
    });
    // [Action] - assign
    dispatch(assignAction(`ATA Number Assigned ${body?.number}`));
    toast.success('ATA Number Assigned Successfully');
  } catch (error) {
    toast.error(error.response.data || 'Something is wrong, try changing the number', {
      toastId: 'UPDATE_ATA_BY_NUMBER',
    });
    dispatch({
      type: 'UPDATE_ATA_BY_NUMBER_ERROR',
      error,
    });
  }
};

export const updateAtaByPortId = (token, ataId, body, epikBoxUser, numId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_ATA_BY_PORT_ID',
  });
  try {
    const updatedAta = await api.numbers.updateAtaByPortId(
      ataId,
      checkIfIsBoxTab(body),
      epikBoxUser,
      numId,
    );
    dispatch({
      type: 'UPDATE_ATA_BY_PORT_ID_SUCCESS',
      updatedAta,
    });
    // [Action] - assign
    dispatch(assignAction(`Number Assigned to ata port ${body?.portID}`));
  } catch (error) {
    toast.error(error?.response?.data || 'Something is wrong, try changing the number', {
      toastId: 'UPDATE_ATA_BY_PORT_ID_ERROR',
    });
    dispatch({
      type: 'UPDATE_ATA_BY_PORT_ID_ERROR',
      error,
    });
  }
};

export const updateAta = (token, obiNumber, body, type) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_OBI_BY_NUMBER',
  });
  try {
    const numbers = await api.numbers.updateObiByNumber(obiNumber, checkIfIsBoxTab(body), type);
    dispatch({
      type: 'UPDATE_OBI_BY_NUMBER_SUCCESS',
      numbers: {
        allNumbers: numbers,
      },
    });
    // [Action] - assign
    dispatch(assignAction(`Number Assigned ${body?.number}`));
  } catch (error) {
    toast.error(error.response.data || 'Something is wrong, try changing the number', {
      toastId: 'UPDATE_ATA_FAILURE',
    });
    dispatch({
      type: 'UPDATE_OBI_BY_NUMBER_ERROR',
      error,
    });
  }
};

export const filterByNumber = (token, id, number, pagination, carrier) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_FILTER_BY_NUMBER',
  });
  try {
    const numbers = await api.numbers.filterByNumber(id, number, pagination, carrier);
    dispatch({
      type: 'GET_FILTER_BY_NUMBER_SUCCESS',
      numbers: {
        allNumbers: numbers,
      },
    });
  } catch (error) {
    dispatch({
      type: 'GET_FILTER_BY_NUMBER_ERROR',
      error,
    });
  }
};

export const filterByEmail = (token, number, pagination) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_NUMBER_BY_EMAIL',
  });
  try {
    const numbers = await api.numbers.filterByEmail(number, pagination);
    dispatch({
      type: 'GET_FILTER_BY_NUMBER_SUCCESS',
      numbers: {
        allNumbers: numbers,
      },
    });
  } catch (error) {
    dispatch({
      type: 'GET_FILTER_BY_NUMBER_ERROR',
      error,
    });
  }
};

export const getNumbers = (
  token,
  paginateOptions,
  id,
  type,
  disablePaginate,
  carrier,
) => dispatch => {
  dispatch({
    type: 'GET_NUMBERS',
  });
  dispatch(getAllNumbers(token, paginateOptions, id, type, disablePaginate, carrier));
};

// Generic method to update number
export const updateNumber = (token, number, pagination, filter, type) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_NUMBER',
    number,
  });
  try {
    const updatedNumber = await api.numbers.updateNumber(checkIfIsBoxTab(number));
    dispatch({
      type: 'UPDATE_NUMBER_SUCCESS',
      number: updatedNumber,
    });
    toast.success(`Number Updated Successfully`, {
      toastId: 'UPDATE_NUMBER_SUCCESS',
    });

    type === 'By Number'
      ? dispatch(filterByNumber(token, number._id, filter, pagination))
      : dispatch(getNumbers(token, pagination, filter, type));

    return true;
  } catch (error) {
    const message = error.response.data;
    dispatch({
      type: 'UPDATE_NUMBER_FAILURE',
      error: message,
    });
    toast.error(error.response.data || 'Something is wrong, try changing the number', {
      toastId: 'UPDATE_NUMBER_FAILURE',
    });
    return false;
  }
};

// Force fix number
export const forceFixNumber = (token, nid, bid) => async () => {
  const api = new Api(token);
  const body = {};
  try {
    await api.numbers.forceFixNumber(nid, bid, checkIfIsBoxTab(body));
    return true;
  } catch (error) {
    const message = error.response.data;
    toast.error(message || 'Something is wrong.');
    return error;
  }
};

export const assignNumberToUser = (token, number, userId) => async dispatch => {
  dispatch({
    type: 'ASSIGN_NUMBER_USER',
  });
  const payload = checkIfIsBoxTab({
    ...number,
    assignedTo: userId,
  });
  try {
    const updatedNumber = await dispatch(updateNumber(token, payload));
    dispatch({
      type: 'ASSIGN_NUMBER_USER_SUCCESS',
      number: updatedNumber,
    });
  } catch (error) {
    dispatch({
      type: 'ASSIGN_NUMBER_USER',
      error,
    });
  }
};

export const assignNumberShow = id => dispatch => {
  dispatch({
    type: 'ASSIGN_NUMBER_USER_SHOW',
    number: id,
  });
};

export const cancelAssignNumber = id => dispatch => {
  dispatch({
    type: 'ASSIGN_NUMBER_USER_CANCEL',
  });
};

export const setActiveNumbersTab = tab => dispatch => {
  dispatch({
    type: 'SET_ACTIVE_NUMBERS_TAB',
    tab,
  });
};

export const revokeUserNumberShow = id => dispatch => {
  dispatch({
    type: 'REVOKE_USER_NUMBER_SHOW',
    id,
  });
};

export const revokeUserNumberCancel = () => dispatch => {
  dispatch({
    type: 'REVOKE_USER_NUMBER_CANCEL',
  });
};

export const assignCompanyNumberShow = id => dispatch => {
  dispatch({
    type: 'ASSIGN_COMPANY_NUMBER_SHOW',
    id,
  });
};

export const assignCompanyNumberCancel = () => dispatch => {
  dispatch({
    type: 'ASSIGN_COMPANY_NUMBER_CANCEL',
  });
};

export const editNumberShow = number => dispatch => {
  dispatch({
    type: 'EDIT_NUMBER_SHOW',
    number,
  });
};

export const editNumberCancel = () => dispatch => {
  dispatch({
    type: 'EDIT_NUMBER_CANCEL',
  });
  dispatch({
    type: 'FILTER_NUMBER_BY_COMPANY_CANCEL',
  });
  dispatch({
    type: 'EDIT_COMPANY_FIELD_CHANGE_CANCEL',
  });
  dispatch({
    type: 'GET_FORWARD_URI_CANCEL',
  });
};

export const editNumberModalCancel = () => dispatch => {
  dispatch({
    type: 'GET_FORWARD_URI_CANCEL',
  });
};

export const addNumberModalCancel = () => dispatch => {
  dispatch({
    type: 'GET_FORWARD_URI_CANCEL',
  });
};

export const showAddNumber = () => dispatch => {
  dispatch({
    type: 'ADD_NUMBER_SHOW',
  });
};

export const cancelAddNumber = () => dispatch => {
  dispatch({
    type: 'ADD_NUMBER_CANCEL',
  });
  dispatch({
    type: 'ADD_EMAIL_FIELD_CHANGE_CANCEL',
  });
  dispatch({
    type: 'GET_FORWARD_URI_CANCEL',
  });
};

export const addNumber = (token, id, number, pagination, filter, type) => async dispatch => {
  const api = new Api(token);
  const isPhoneNumberValid = utils.verifyPhoneNumber(number?.number);
  if (isPhoneNumberValid) {
    dispatch({
      type: 'ADD_NUMBER',
      number,
    });
    try {
      const addedNumber = await api.numbers.addNewNumber(checkIfIsBoxTab(number), id);
      dispatch({
        type: 'ADD_NUMBER_SUCCESS',
        number: addedNumber,
      });
      toast.success(`Number created successfully`, {
        toastId: 'ADD_NUMBER_SUCCESS',
      });
      dispatch(getNumbers(token, pagination, filter, type));
      return addedNumber;
    } catch (error) {
      const message = error.response.data;
      dispatch({
        type: 'ADD_NUMBER_ERROR',
        error: message,
      });
      toast.error(error.response.data || 'Something is wrong, try changing the number', {
        toastId: 'ADD_NUMBER_ERROR',
      });
      return false;
    }
  }
};

export const deleteNumberById = (token, id, number, pagination, filter, type) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_NUMBER',
    id,
  });
  try {
    const deletedNumber = await api.numbers.deleteNumberById(checkIfIsBoxTab(number), id);
    dispatch({
      type: 'DELETE_NUMBER_SUCCESS',
      id,
    });
    toast.success(`Number deleted successfully`, {
      toastId: 'DELETE_NUMBER_SUCCESS',
    });
    dispatch(getNumbers(token, pagination, filter, type));
    return deletedNumber;
  } catch (error) {
    const message = error.response.data;
    dispatch({
      type: 'DELETE_NUMBER_ERROR',
      error: message,
    });
    toast.error(error.response.data || 'Something is wrong, try changing the number', {
      toastId: 'DELETE_NUMBER_ERROR',
    });
    return { error };
  }
};

export const addBulkNumber = (token, body) => async dispatch => {
  const api = new Api(token);

  try {
    const addedNumber = await api.numbers.addBulkNumber(checkIfIsBoxTab(body));
    dispatch({
      type: 'ADD_BULK_NUMBER_SUCCESS',
      number: addedNumber,
    });
    toast.success(`Number created successfully`, {
      toastId: 'ADD_BULK_NUMBER_SUCCESS',
    });
    return true;
  } catch (error) {
    const message = error.response.data;
    dispatch({
      type: 'ADD_BULK_NUMBER_ERROR',
      error: message,
    });
    toast.error(error.response.data || 'Something is wrong, try changing the number', {
      toastId: 'ADD_BULK_NUMBER_ERROR',
    });
    return { error };
  }
};

export const addNumberFieldChange = (name, value) => dispatch => {
  dispatch({
    type: 'ADD_NUMBER_FIELD_CHANGE',
    name,
    value,
  });
};

export const addEmailFieldChange = emails => dispatch => {
  dispatch({
    type: 'ADD_EMAIL_FIELD_CHANGE',
    emails,
  });
};

export const editEmailFieldChange = emails => dispatch => {
  dispatch({
    type: 'EDIT_ALL_EMAIL_FIELD_CHANGE',
    emails,
  });
};

export const editNumberFieldChange = (name, value) => dispatch => {
  dispatch({
    type: 'EDIT_NUMBER_FIELD_CHANGE',
    name,
    value,
  });
};

export const editNumberField = (name, value) => dispatch => {
  dispatch({
    type: 'EDIT_NUMBER_FIELD',
    name,
    value,
  });
};

export const editCompanyFieldChange = (name, value) => dispatch => {
  dispatch({
    type: 'EDIT_COMPANY_FIELD_CHANGE',
    name,
    value,
  });
};

export const assignNumberFieldChange = ({ name, value }) => dispatch => {
  dispatch({
    type: 'ASSIGN_NUMBER_FIELD_CHANGE',
    name,
    value,
  });
};

export const filterNumbersByCompany = (filter = null) => async dispatch => {
  dispatch({
    type: 'FILTER_NUMBER_BY_COMPANY',
    filter,
  });
};

export const filterPagination = (pagination = null) => async dispatch => {
  dispatch({
    type: 'FILTER_PAGINATION',
    pagination,
  });
};

export const getForwardUri = (token, obiNumber, portName, name, externaleAta) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_FORWARD_URI',
  });
  try {
    const forwardUri = await api.numbers.getForwardUri(obiNumber, portName, externaleAta);
    dispatch({
      type: 'GET_FORWARD_URI_SUCCESS',
      forwardUri,
    });
    return forwardUri;
  } catch (error) {
    dispatch({
      type: 'GET_FORWARD_URI_ERROR',
      error,
    });
  }
};

export const getNumberAssignmentLog = (token, numberID) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_NUMBER_ASSIGNMENT_LOG',
  });
  try {
    const forwardUri = await api.numbers.getNumberAssignmentLog(numberID);
    dispatch({
      type: 'GET_NUMBER_ASSIGNMENT_LOG',
    });
    return forwardUri;
  } catch (error) {
    console.error(error)
    dispatch({
      type: 'GET_NUMBER_ASSIGNMENT_LOG_ERROR',
    });
  }
};

export const uploadFile = (token, id, files) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPLOAD_FILES',
  });
  try {
    const obj = checkIfIsBoxTab(files);
    if (files) Object.entries(obj).map(([key, value]) => files.append(key, value));
    await api.numbers.uploadFile(id, files ? files : obj);
    dispatch({
      type: 'UPLOAD_FILES_SUCCESS',
    });
    toast.success('File upload success', {
      toastId: 'UPLOAD_FILES_SUCCESS',
    });
  } catch (error) {
    toast.error(error.response.data || 'Something is wrong, file upload error', {
      toastId: 'UPLOAD_FILES_ERROR',
    });
    dispatch({
      type: 'UPLOAD_FILES_ERROR',
      error,
    });
  }
};

export const forceUnlinkNumberFromBox = (token, numberId) => async dispatch => {
  const api = new Api(token);
  try {
    const updatedNumber = await api.numbers.forceUnlinkNumberFromBox(numberId);
    dispatch({
      type: 'UPDATE_NUMBER_SUCCESS',
      number: updatedNumber,
    });
    dispatch(filterByNumber(token, updatedNumber?._id, updatedNumber?.number, {}, ''))
    toast.success(`Number Force Unlinked Successfully`);
    return true;
  } catch (error) {
    dispatch({
      type: 'GET_NUMBER_ASSIGNMENT_LOG_ERROR',
    });
    toast.error(error?.response?.data);
    return false;
  }
};